// Customer testimonials for the Absolute Hammer landing page.
// Charles + Adam + Sara are real Google reviews; one placeholder (Jack H.) remains
// until more real ones come in (then remove it and update reviewCount in index.html).

export const HAMMER_REVIEWS = [
  {
    quote:
      '“I purchased one of their air hammers and it has been the best one my company has owned to date. Everything I had seen done wrong by other manufacturers, they corrected — and they answer the phone. I will definitely buy from them again.”',
    name: 'Charles Hodges',
    attribution: 'Licensed Marine Contractor, FL (Google review)',
    rating: 5,
  },
  {
    quote:
      '“Clever hammer design, low maintenance and reliable! Great dealings with the company as well!”',
    name: 'Adam Greene',
    attribution: 'Sea Dog Marine Construction, NC (Google review)',
    rating: 5,
  },
  {
    quote: '"Purchased a pile hammer from Absolute Marine Equipment and have been really impressed with it so far! It’s a solid piece of equipment and has done exactly what we needed it to do. It feels well built, works efficiently, and has handled the demands of jobs. The quality of this one definitely stands out. Would have no problem buying from Absolute Marine Equipment again!"',
    name: 'Sara H.',
    attribution: 'Verified Google review · Absolute Hammer owner',
    rating: 5,
  },
  {
    quote:
      '“Solid, simple, galvanized. No hydraulic mess, just air in and pilings down. Best purchase we made last year.”',
    name: 'Jack H.',
    attribution: 'Gulfshore Marine',
    rating: 5,
  },
];
